
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"nonzero"}},[_c('path',{attrs:{"fill":"#FFF","stroke":"#FFF","stroke-linejoin":"round","stroke-width":"3","d":"M28.354 13.066c2.55-.13 5.1.25 7.498 1.117a19.317 19.317 0 0110.974 9.96 19.318 19.318 0 01.726 14.802 19.364 19.364 0 01-33.781 5.003 16.336 16.336 0 0012.4-3.038 16.322 16.322 0 005.63-7.658 16.376 16.376 0 00.459-9.45 16.376 16.376 0 00-4.841-8.13 16.423 16.423 0 00-2.773-2.048 19.166 19.166 0 013.708-.558z"}}),_c('g',{attrs:{"stroke":"#333"}},[_c('path',{attrs:{"fill":"#C9C7B9","d":"M46.14 38.44a17.864 17.864 0 01-28.828 7.195 17.835 17.835 0 0015.903-11.88 17.892 17.892 0 00-4.784-19.19c2.35-.121 4.701.229 6.914 1.03C44.63 18.926 49.46 29.15 46.14 38.438z"}}),_c('path',{attrs:{"fill":"#333","d":"M37.264 29.423a1.609 1.609 0 011.722 1.51 1.616 1.616 0 10-3.232 0 .07.07 0 01-.07 0 1.623 1.623 0 011.58-1.51h0zm5.546 0a1.623 1.623 0 011.707 1.51.07.07 0 01-.07 0 1.609 1.609 0 00-3.161 0 .07.07 0 01-.141 0 1.609 1.609 0 011.665-1.51z"}})])])])
          )
        }
      }
    